import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useScrollReveal } from '@/hooks/use-scroll-reveal';
import { trackCta } from '@/lib/analytics';

export const TypicalProjectSection = () => {
  const { elementRef, getRevealStyle } = useScrollReveal();

  return (
    <section className="py-24 bg-[#0a0a0a] relative overflow-hidden">
      <div className="container-professional" ref={elementRef} style={getRevealStyle()}>
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-primary font-mono mb-4">
            Project Shape
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-8">
            What a typical project looks like
          </h2>
          <div className="space-y-6 text-left md:text-center">
            <p className="text-base md:text-lg text-[rgba(255,255,255,0.65)] leading-relaxed">
              Most of our projects start with a single, specific problem. A sales team spending two hours a day on lead research that could be automated. A service business managing 40 active clients in a spreadsheet that keeps breaking. An internal approval process that relies on someone chasing people down on Teams.
            </p>
            <p className="text-base md:text-lg text-[rgba(255,255,255,0.65)] leading-relaxed">
              We sit down, map the problem, design the right tool, and build it. Most projects go from confirmed brief to live product in 2 to 4 weeks. After launch we stay available for tweaks, new features, and ongoing support as your needs grow.
            </p>
          </div>
          <div className="mt-10 flex justify-center">
            <Link to="/contact" onClick={trackCta('book_discovery_call', 'typical_project')}>
              <button
                className="group h-12 px-7 text-sm bg-primary hover:bg-[#1aeaff] text-[#001216] font-semibold rounded-xl transition-all duration-200 hover:-translate-y-0.5 flex items-center gap-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-[#0a0a0a]"
              >
                <span>Book a free 30 minute call</span>
                <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-0.5" strokeWidth={2.25} />
              </button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
